<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="926.334"
    height="588.846"
    viewBox="0 0 926.334 588.846"
  >
    <g
      id="Illustration_-_Business_Startup_workflow_error___exhaustion_exhausted_work_laptop_computer_support"
      data-name="Illustration - Business, Startup, workflow, error _ exhaustion, exhausted, work, laptop, computer, support"
      transform="translate(-47.583 -389.358)"
    >
      <path
        id="Контур_905"
        data-name="Контур 905"
        d="M198.088,736.272a145.162,145.162,0,0,1,73.439-50.255,219.262,219.262,0,0,1-9.239-32.122C238.04,535.963,313.873,420.668,431.775,396.348s233.238,51.483,257.547,169.385a222.765,222.765,0,0,1,4.517,40.129,193.463,193.463,0,0,1,25.8-7.186c103.037-21.3,203.847,44.995,225.118,148.053a190.241,190.241,0,0,1-43.866,164.724"
        transform="translate(3.93 0)"
        fill="none"
        stroke="#9f9f9f"
        stroke-width="4.83"
      />
      <path
        id="Контур_932"
        data-name="Контур 932"
        d="M434.524,706.971l14.622-1.659-2.819-24.84,17.031-1.933-1.517-13.375L444.81,667.1l-9.265-81.665-21.683,2.46c-13.945,26.91-28.987,58.237-42.105,87.241l1.545,13.625,58.4-6.626ZM387.081,673.73l-.114-1c10.546-23.5,23.439-50.034,34.616-71.665l1-.114,7.7,67.874Zm142.639,25.3c26.5-3.007,39.709-28.992,35.336-67.54l-.019-.167c-4.373-38.548-23.058-60.831-49.559-57.823s-39.554,28.89-35.18,67.438l.019.166C484.691,679.654,503.218,702.038,529.721,699.032Zm-1.479-13.043c-17.2,1.951-29.418-16.017-32.887-46.589l-.019-.166c-3.469-30.573,4.435-50.656,21.632-52.606s29.565,15.831,33.034,46.4l.019.166C553.489,663.77,545.438,684.038,528.241,685.989Zm122.951-3.6,14.622-1.659L663,655.891l17.031-1.932-1.517-13.376-17.031,1.933-9.266-81.665-21.683,2.46c-13.945,26.909-28.987,58.235-42.105,87.24l1.545,13.625,58.4-6.626Zm-47.443-33.241-.114-1c10.546-23.5,23.439-50.034,34.616-71.665l1-.112,7.7,67.874Z"
        transform="translate(-50.246 -59.049)"
        fill="rgba(5,117,221,0.7)"
      />
      <path
        id="Контур_899"
        data-name="Контур 899"
        d="M914.835,967H642.31L827.5,964.854c34.236-2.977,58.361-36.556,45.354-68.349-2.248-5.492.1-7.022-2.679-12.319-29.114-54.819-79.59-99.475-136.791-125.417,1.417-.267,2.844-.462,4.3-.657a290.007,290.007,0,0,0-32.85-13.992c-5.954-2.125-11.98-4.045-18-5.728-29.576-8.336-69.54-4.527-82.126,28.221-10.584,27.492,3.47,60.7,29.9,72.743l47.479,18.15c-.4-.6-.76-1.191-1.129-1.817l41.289,15.778a4.907,4.907,0,0,1-2.31,8.9L619.674,891.321c-14.454,1.458-32.553,7.5-43.209,17.452-7.771,7.186-14.321,16.969-14.259,29.35a153.02,153.02,0,0,0-19.5,2.741c-9.824,2.115-19.823,5.759-20.531,11.744-1.4,12.011,15.676,14.454,26.434,14.454l-68.082-.267c7.309,0,8.213-.062,13.058-4.887s10.266-8.541,10.266-15.85l.6-23.426c0-4.825,1.15-8.726-3.675-8.726H457.65a9.148,9.148,0,0,0,8.469-5.133.254.254,0,0,0,.062-.133c2.156-4,2.649-9.763,2.248-15.214l.5-1.786,1.293-4.763,27.389-16.117a6.527,6.527,0,0,0,.6-.39c14.29-8.736,16.076-24.35,11.179-38.312-.1-.267-.164-.5-.267-.729-.226-.6-.431-1.16-.688-1.725a52.163,52.163,0,0,0-4.835-9.1c-7.073-11.046-17.339-20.049-27.091-22.4a37.58,37.58,0,0,0-8.336-.924c33.939-31.824,73.041-60.106,119.226-69.509a268.189,268.189,0,0,1,122.121,3.182c46.648,12.411,88.655,38.178,121.967,72.979C876.328,850.617,897.3,905.272,914.835,967Z"
        transform="translate(10.833 8.778)"
        fill="#353642"
      />
      <path
        id="Контур_900"
        data-name="Контур 900"
        d="M460.641,824.012a15.765,15.765,0,0,1-7.473,7.186,36.839,36.839,0,0,1-8.7,3.08c-4.969.831-6.724-2.31-9.9-5.39a23.248,23.248,0,0,0-6.159-4.271,10.272,10.272,0,0,0-8.767-.133,5.3,5.3,0,0,0-3.141,4.835c.205,3.768,5.4,6.745,8.336,8.3a72.306,72.306,0,0,0,11.908,4.394c10.03,3.08-6.673,9.5-10.184,9.9a71.672,71.672,0,0,1-22.585-.534,76.191,76.191,0,0,1,4.9,14.885c1.16,4.9,2.515,10.789,1.56,15.717-1.16,5.79-5.071,10.091-9.9,13.007L381.79,816.744a55.608,55.608,0,0,1,44.492-1.458,13.2,13.2,0,0,0,13.931-3.08l1.92-1.858a13.884,13.884,0,0,1,8.007.636C454.687,812.7,463.1,818.212,460.641,824.012Z"
        transform="translate(8.817 11.114)"
        fill="#0575dd"
      />
      <path
        id="Контур_901"
        data-name="Контур 901"
        d="M486.871,908.879H409.426a29.77,29.77,0,0,1-29.606,26.6H119.46a26.631,26.631,0,0,0,26.568,26.568H486.851a26.693,26.693,0,0,0,26.6-26.568V917.615a8.734,8.734,0,0,0-8.736-8.736Z"
        transform="translate(1.846 13.741)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_902"
        data-name="Контур 902"
        d="M369.121,740.02a29.585,29.585,0,0,1,4.835,10.512l36.69,152.96a28.742,28.742,0,0,1,.626,10.153,29.77,29.77,0,0,1-29.606,26.6H116.47a29.821,29.821,0,0,1-28.98-22.862L50.842,764.422a29.772,29.772,0,0,1,28.98-36.762H344.976A29.62,29.62,0,0,1,367.8,738.347Z"
        transform="translate(0 8.925)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_903"
        data-name="Контур 903"
        d="M236.535,873.676c15.1-4.762,23.007-22.381,17.655-39.355s-21.933-26.873-37.036-22.111-23.007,22.381-17.655,39.355S221.432,878.437,236.535,873.676Z"
        transform="translate(3.928 11.141)"
        fill="rgba(5,117,221,0.1)"
      />
      <path
        id="Контур_904"
        data-name="Контур 904"
        d="M735.252,756.815c-23.4,3.911-41.381,14.608-53.454,36.751-10.81,19.813-12.073,43.989-.544,63.648l-47.068-18.047c-27.256-12.483-36.844-40.221-25.921-68.709,12.986-33.939,54.193-37.881,84.692-29.237,6.211,1.745,12.411,3.737,18.55,5.934Q723.538,751.467,735.252,756.815Z"
        transform="translate(14.718 9.182)"
        fill="#353642"
      />
      <path
        id="Контур_906"
        data-name="Контур 906"
        d="M448.23,914h7.278a13.473,13.473,0,0,0,10.912-5.133.324.324,0,0,0,.072-.133,17.811,17.811,0,0,0,3.336-12.38l-.6-4.63-.493-3.737,1.786-1.027,27.984-16.507,1.889-1.088c13.664-8.038,14.649-23.026,9.29-37.224-.092-.257-.164-.493-.257-.729-.236-.6-.472-1.15-.7-1.714a65.6,65.6,0,0,0-4.835-9.1c-7.073-11.056-17.329-20.049-27.091-22.4a36.975,36.975,0,0,0-8.336-.924c-5.852,0-12.319,1.119-15.717,4.5,36.3-35.715,78.707-69.232,129.718-79.631a268.2,268.2,0,0,1,122.162,3.244c46.648,12.411,88.7,38.21,122.008,73.011,1.755,1.827,3.47,3.674,5.133,5.563,41.751,45.888,68.38,103.848,85.206,163.164"
        transform="translate(10.583 8.632)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_907"
        data-name="Контур 907"
        d="M460.7,960.672H963"
        transform="translate(10.914 15.118)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_908"
        data-name="Контур 908"
        d="M583.88,960.66h57"
        transform="translate(14.188 15.117)"
        fill="none"
        stroke="#000"
        stroke-width="3.22"
      />
      <path
        id="Контур_909"
        data-name="Контур 909"
        d="M632.171,838.769c-26.445-12.042-40.488-45.251-29.914-72.733,12.606-32.758,52.571-36.567,82.126-28.231q9.054,2.536,18,5.728c66.45,23.611,126.833,72.63,159.807,134.738,2.782,5.256,5,10.656,7.248,16.158a50.948,50.948,0,0,1-42.726,70.084l-185.184,2.166h-57A24.113,24.113,0,0,1,561.7,950.338c-6.252-18.478,1.827-32.419,12.042-41.915,10.656-9.9,24.556-15.553,39.01-17.01L716.781,880.9a4.917,4.917,0,0,0,2.33-8.911Z"
        transform="translate(13.54 9.094)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_910"
        data-name="Контур 910"
        d="M600.686,907c-9.5,5.461-19.259,14.013-22.523,24.843-3.757,12.473,5.061,23.806,15.08,30.294"
        transform="translate(14.012 13.691)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_911"
        data-name="Контур 911"
        d="M610.338,920.941c-8.859,8.428-16.538,19.115-11.416,31.824a23.6,23.6,0,0,0,6.652,8.993"
        transform="translate(14.544 14.062)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_912"
        data-name="Контур 912"
        d="M627.234,937s-20.4,15.163-7.443,24.258"
        transform="translate(15.028 14.489)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_913"
        data-name="Контур 913"
        d="M577.4,959.961l.359,1.458H544.85c-10.758,0-25.664-1.653-24.258-13.664s39.934-15.286,39.934-15.286"
        transform="translate(12.503 14.368)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_914"
        data-name="Контур 914"
        d="M468.463,884.2s-2.135-18.786-9.373-25.408"
        transform="translate(10.871 12.41)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_915"
        data-name="Контур 915"
        d="M381.09,818.339a55.68,55.68,0,0,1,45.169-1.745,13.225,13.225,0,0,0,13.951-3.08l14.3-14"
        transform="translate(8.799 10.835)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_916"
        data-name="Контур 916"
        d="M425.37,895.593l11.939,5.369a2.048,2.048,0,0,0,1.668-.045,2.059,2.059,0,0,0,1.083-1.269l1.879-4.25"
        transform="translate(9.975 13.383)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_917"
        data-name="Контур 917"
        d="M427.32,872.488a13.61,13.61,0,0,1-1.95,14.064"
        transform="translate(9.975 12.774)"
        fill="none"
        stroke="#000"
        stroke-width="3.22"
      />
      <path
        id="Контур_918"
        data-name="Контур 918"
        d="M454,909.237c1.879-2.782,1.868-9.507,1.386-12.207-.308-1.714-3.193-2.329-3.5-.6-.842,4.815-6.272,12.216-11.292,12.812"
        transform="translate(10.38 13.383)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_919"
        data-name="Контур 919"
        d="M430.567,891.993a15.327,15.327,0,1,0-15.327-15.327A15.327,15.327,0,0,0,430.567,891.993Z"
        transform="translate(9.706 12.478)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_920"
        data-name="Контур 920"
        d="M425.747,890.328l-2.731,7.679a15.318,15.318,0,0,0-19.577,9.3"
        transform="translate(9.392 13.248)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_921"
        data-name="Контур 921"
        d="M430.506,889.581A12.976,12.976,0,1,0,417.53,876.6,12.976,12.976,0,0,0,430.506,889.581Z"
        transform="translate(9.767 12.539)"
        fill="#fff"
        opacity="0.53"
      />
      <path
        id="Контур_922"
        data-name="Контур 922"
        d="M400,895.968c4.825-2.915,8.726-7.186,9.886-13,.965-4.938-.39-10.82-1.55-15.717a75.938,75.938,0,0,0-4.9-14.885,71.671,71.671,0,0,0,22.585.523c3.5-.39,20.213-6.775,10.184-9.886a70.978,70.978,0,0,1-11.9-4.4c-2.957-1.53-8.141-4.507-8.326-8.284a5.263,5.263,0,0,1,3.08-4.856,10.263,10.263,0,0,1,8.767.154,22.583,22.583,0,0,1,6.159,4.271c3.182,3.08,4.917,6.159,9.906,5.369a35.813,35.813,0,0,0,8.675-3.08,15.78,15.78,0,0,0,7.494-7.186c2.484-5.78-5.954-11.292-10.533-12.945a13.923,13.923,0,0,0-8-.657"
        transform="translate(9.301 11.142)"
        fill="none"
        stroke="#000"
        stroke-width="4.83"
      />
      <path
        id="Контур_923"
        data-name="Контур 923"
        d="M731.888,757l-.431.729a7.261,7.261,0,0,0-1.027-.534Z"
        transform="translate(18.082 9.705)"
        fill="#353642"
      />
      <path
        id="Контур_924"
        data-name="Контур 924"
        d="M432.2,708.744l-2.658.3A2.675,2.675,0,0,0,432.5,711.4Zm14.622-1.659.3,2.658a2.674,2.674,0,0,0,2.356-2.959ZM444,682.246l-.3-2.658a2.675,2.675,0,0,0-2.357,2.959Zm17.031-1.933.3,2.659a2.677,2.677,0,0,0,2.357-2.961Zm-1.517-13.375,2.658-.3a2.674,2.674,0,0,0-2.959-2.357Zm-17.031,1.932-2.658.3a2.676,2.676,0,0,0,2.961,2.357Zm-9.265-81.664,2.659-.3a2.678,2.678,0,0,0-2.96-2.357Zm-21.683,2.459-.3-2.658a2.675,2.675,0,0,0-2.074,1.427Zm-42.105,87.241-2.439-1.1a2.694,2.694,0,0,0-.221,1.4Zm1.545,13.625-2.658.3a2.675,2.675,0,0,0,2.961,2.357Zm58.4-6.626,2.658-.3a2.675,2.675,0,0,0-2.961-2.356Zm-44.626-8.4-2.66.3a2.675,2.675,0,0,0,2.961,2.356Zm-.114-1-2.441-1.1a2.664,2.664,0,0,0-.217,1.4Zm34.616-71.665-.3-2.658a2.675,2.675,0,0,0-2.076,1.43Zm1-.112,2.658-.3a2.676,2.676,0,0,0-2.959-2.357Zm7.7,67.874.3,2.658a2.677,2.677,0,0,0,2.357-2.96Zm4.546,40.8,14.622-1.659-.6-5.316L431.9,706.086Zm16.978-4.618-2.817-24.841-5.318.6,2.819,24.841Zm-5.174-21.88,17.031-1.932-.6-5.318L443.7,679.588Zm19.388-4.892-1.518-13.375-5.316.6,1.517,13.375Zm-4.478-15.732-17.031,1.932.6,5.318,17.03-1.933Zm-14.072,4.289L435.88,586.9l-5.318.6,9.265,81.665ZM432.92,584.546l-21.684,2.46.6,5.318,21.684-2.46Zm-23.758,3.888c-13.97,26.96-29.034,58.329-42.168,87.369l4.876,2.2c13.1-28.968,28.124-60.25,42.044-87.111Zm-42.389,88.774,1.546,13.624,5.316-.6L372.091,676.6Zm4.507,15.981,58.4-6.626-.6-5.316-58.4,6.626Zm55.443-8.983,2.819,24.841,5.316-.6L432.041,683.6Zm-39.308-9-.114-1-5.316.6.112,1Zm-.33.4c10.523-23.447,23.4-49.941,34.552-71.533l-4.754-2.456c-11.2,21.672-24.112,48.254-34.681,71.8Zm32.476-70.1,1-.112-.6-5.318-1,.114Zm-1.963-2.47,7.7,67.874,5.318-.6-7.7-67.874Zm10.057,64.914-43.2,4.9.6,5.316,43.2-4.9ZM527.7,703.464c14.187-1.609,24.865-9.433,31.32-21.868,6.4-12.321,8.6-29.04,6.374-48.632l-5.318.6c2.151,18.956-.065,34.5-5.806,45.564-5.682,10.946-14.859,17.618-27.174,19.015Zm37.695-70.5-.02-.166-5.316.6.019.166Zm-.02-.166c-2.222-19.592-8.111-35.373-17.1-45.928-9.077-10.654-21.233-15.862-35.416-14.253l.6,5.316c12.32-1.4,22.756,3.033,30.741,12.406,8.068,9.471,13.708,24.105,15.859,43.061Zm-52.519-60.181c-14.186,1.609-24.828,9.406-31.244,21.82-6.356,12.3-8.516,28.991-6.294,48.577l5.318-.6c-2.151-18.961.028-34.482,5.73-45.516,5.641-10.916,14.777-17.563,27.093-18.961Zm-37.538,70.4.019.167,5.318-.6-.019-.167Zm.019.167c2.222,19.586,8.069,35.391,17.019,45.972,9.035,10.681,21.154,15.919,35.344,14.31l-.6-5.318c-12.312,1.4-22.707-3.053-30.655-12.449-8.033-9.5-13.636-24.157-15.787-43.119Zm50.28,41.922c-7.4.84-13.878-2.5-19.1-9.972-5.284-7.562-9.121-19.206-10.829-34.26l-5.316.6c1.761,15.519,5.767,28.147,11.76,36.721,6.057,8.672,14.289,13.336,24.085,12.225Zm-29.926-44.232-.019-.166-5.316.6.019.166Zm-.019-.166c-1.707-15.054-.571-27.215,2.887-35.726,3.413-8.4,8.978-13.078,16.389-13.919l-.6-5.316c-9.787,1.11-16.772,7.447-20.744,17.221-3.925,9.661-5.006,22.826-3.245,38.344Zm19.276-49.646c7.414-.84,13.93,2.474,19.178,9.893,5.315,7.514,9.187,19.106,10.895,34.154l5.316-.6c-1.761-15.523-5.807-28.109-11.842-36.641-6.1-8.627-14.369-13.229-24.151-12.119Zm30.073,44.047.019.166,5.316-.6-.019-.166Zm.019.166c1.707,15.049.535,27.257-2.959,35.816-3.451,8.455-9.059,13.176-16.464,14.014l.6,5.318c9.792-1.11,16.809-7.5,20.815-17.309,3.964-9.705,5.084-22.917,3.322-38.442Zm103.831,48.891-2.658.3a2.676,2.676,0,0,0,2.96,2.357Zm14.622-1.66.3,2.66a2.675,2.675,0,0,0,2.356-2.961Zm-2.819-24.839-.3-2.658a2.675,2.675,0,0,0-2.357,2.96Zm17.031-1.932.3,2.658a2.676,2.676,0,0,0,2.357-2.961Zm-1.517-13.376,2.658-.3a2.675,2.675,0,0,0-2.959-2.357Zm-17.031,1.933-2.658.3a2.675,2.675,0,0,0,2.961,2.357Zm-9.265-81.665,2.659-.3a2.676,2.676,0,0,0-2.96-2.356Zm-21.683,2.46-.3-2.66a2.68,2.68,0,0,0-2.073,1.429ZM586.1,652.324l-2.439-1.1a2.7,2.7,0,0,0-.221,1.4Zm1.545,13.625-2.658.3a2.674,2.674,0,0,0,2.96,2.356Zm58.4-6.626,2.658-.3a2.675,2.675,0,0,0-2.961-2.357Zm-44.626-8.4-2.659.3a2.677,2.677,0,0,0,2.961,2.357Zm-.114-1-2.441-1.1a2.669,2.669,0,0,0-.217,1.4Zm34.616-71.665-.3-2.658a2.675,2.675,0,0,0-2.076,1.43Zm1-.112,2.658-.3a2.674,2.674,0,0,0-2.959-2.356Zm7.7,67.874.3,2.658a2.676,2.676,0,0,0,2.357-2.96Zm4.546,40.8,14.622-1.659-.6-5.318L648.567,681.5Zm16.978-4.619-2.817-24.839-5.318.6,2.819,24.84Zm-5.175-21.88,17.031-1.932-.6-5.316-17.031,1.932Zm19.388-4.892-1.518-13.375-5.316.6,1.517,13.375ZM675.885,639.7l-17.031,1.932.6,5.318,17.03-1.932Zm-14.072,4.289-9.264-81.665-5.318.6L656.5,644.59Zm-12.225-84.021L627.9,562.425l.6,5.318,21.684-2.46Zm-23.758,3.888c-13.97,26.959-29.034,58.329-42.168,87.368l4.876,2.206c13.1-28.969,28.124-60.251,42.044-87.112Zm-42.389,88.773,1.547,13.625,5.316-.6-1.545-13.625Zm4.507,15.981,58.4-6.626-.6-5.316-58.4,6.626Zm55.443-8.982,2.819,24.84,5.316-.6-2.817-24.839Zm-39.308-9-.114-1-5.316.6.112,1Zm-.33.4c10.523-23.447,23.4-49.94,34.552-71.533l-4.755-2.456c-11.2,21.672-24.112,48.254-34.681,71.8Zm32.476-70.1,1-.114-.6-5.316-1,.112Zm-1.963-2.471,7.7,67.874,5.318-.6-7.7-67.874Zm10.057,64.915-43.2,4.9.6,5.318,43.2-4.9Z"
        transform="translate(-54.596 -63.498)"
      />
      <path
        id="Контур_925"
        data-name="Контур 925"
        d="M401.689,730.641l4.393-1.31-2.224-7.463,5.116-1.526-1.2-4.018-5.117,1.526-7.312-24.537-6.515,1.943c-2.8,9.016-5.7,19.446-8.135,29.057l1.22,4.094,17.548-5.23Zm-16.368-7.6-.09-.3c1.948-7.783,4.449-16.627,6.691-23.872l.3-.09,6.077,20.393Z"
        transform="translate(3.856 -5.388)"
        fill="rgba(5,117,221,0.6)"
        stroke="#69acea"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Контур_927"
        data-name="Контур 927"
        d="M389.935,795.048l2.717.766,1.3-4.617,3.165.891.7-2.485-3.165-.891,4.275-15.178L394.9,772.4c-4.428,3.769-9.371,8.242-13.8,12.443l-.712,2.533,10.854,3.056Zm-6.017-9.343.052-.186c3.576-3.408,7.79-7.188,11.344-10.22l.185.052-3.552,12.613Z"
        transform="translate(17.78 10.114)"
        fill="rgba(5,117,221,0.2)"
        stroke="#cde3f8"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Контур_931"
        data-name="Контур 931"
        d="M435.106,771.006c6.7.53,11.208-5.259,11.978-15l0-.042c.77-9.738-2.778-16.143-9.473-16.673s-11.164,5.241-11.934,14.979l0,.042C424.907,764.053,428.411,770.476,435.106,771.006Zm.261-3.3c-4.344-.344-6.5-5.372-5.891-13.095l0-.042c.611-7.723,3.529-12.308,7.874-11.964s6.547,5.333,5.936,13.056l0,.042C442.675,763.432,439.711,768.054,435.367,767.71Z"
        transform="translate(19.981 -4.334)"
        fill="rgba(5,117,221,0.4)"
        stroke="#9bc8f1"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
